import { useMemo } from 'react';
import { useGrowthBookValues } from '../contexts/GrowthBookContext';

// Flat shape sent up with auth events for analytics — only the dimensions
// that affect the user's funnel (post-signup flow, magic-link variant) are
// interesting here. Per-step video URLs are content config, not experiment
// dimensions.
export const useGBValue = () => {
  const { navType, magicLink, landerContent } = useGrowthBookValues();

  return useMemo(
    () => ({
      'lander-content': landerContent || 'none',
      'createaitrans-paywall-nav-config': navType,
      'createaitrans-magicLink': magicLink,
    }),
    [navType, magicLink, landerContent],
  );
};
